import script from "./dclist.vue?vue&type=script&setup=true&lang=js"
export * from "./dclist.vue?vue&type=script&setup=true&lang=js"

import "./dclist.vue?vue&type=style&index=0&id=f0ee7d3c&lang=scss"

const __exports__ = script;

export default __exports__